import React from 'react';
import PropTypes from 'prop-types';

// Components
import Button from 'components/atoms/Button';

// Constants
import { VEHICLE_ROUTE } from 'constants/routes';
import { NAVIGATION } from 'constants/navigations';
import { APP_FLOW } from 'constants/appFlow';

import './CustomerVehicleFooter.scss';
const { FORWARD } = NAVIGATION;
const { IM_NEW_HERE } = APP_FLOW;
const ns = 'customer-vehicle-footer';

const CustomerVehicleFooter = ({
  goTo,
  gtmUserEvent,
  setAppFlow,
  restartVehicleFrom,
  onClick,
  intl
}) => (
  <div className={ns}>
    <span className={`${ns}__text`}>
      {intl.formatMessage({
        id: 'c8.start.page.modal.dont.see.your.vehicle'
      })}
    </span>
    <Button
      buttonTheme={'link'}
      tabIndex={0}
      onClick={() => {
        gtmUserEvent(
          'Add Vehicle Button',
          'Clicked',
          'Add Vehicle Selected',
          'GTM_CURRENT_PAGE > Schedule Your Service Section > Choose Vehicle',
          ''
        );
        restartVehicleFrom();
        setAppFlow(IM_NEW_HERE);
        onClick();
        goTo(VEHICLE_ROUTE, FORWARD);
      }}
      aria-label={intl.formatMessage({
        id: 'c8.aria.add.vehicle',
        defaultMessage: `Add a new vehicle`
      })}
    >
      {intl.formatMessage({
        id: 'c8.common.add.vehicle'
      })}
    </Button>
  </div>
);

CustomerVehicleFooter.propTypes = {
  goTo: PropTypes.func.isRequired,
  gtmUserEvent: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  restartVehicleFrom: PropTypes.func.isRequired,
  setAppFlow: PropTypes.func.isRequired
};

CustomerVehicleFooter.defaultProps = {
  onClick: () => {}
};

export default CustomerVehicleFooter;



// WEBPACK FOOTER //
// ./src/components/molecules/CustomerVehicleFooter/CustomerVehicleFooter.js